import { RJSFSchema } from '@rjsf/utils';
import Form from '@rjsf/material-ui';
import validator from '@rjsf/validator-ajv8';
import produce from 'immer';
import { useDispatch } from 'react-redux';
import {
  addEntrataCredentials,
  addYardiSippCredentials,
  updateEntrataCredentials,
  updateYardiSippCredentials,
  addSFTPCredentials,
  updateSFTPCredentials,
} from '../../../redux/actions/clients';

const entrataCredentialsForm: RJSFSchema = {
  title: 'Add Entrata API Credentials',
  type: 'object',
  properties: {
    Type: {
      type: 'string',
      default: 'API',
      readOnly: true,
      title: 'Type',
    },
    URL: {
      type: 'string',
      title: 'URL',
    },
    Username: {
      type: 'string',
      title: 'Username',
    },
    Password: {
      type: 'string',
      title: 'Password',
    },
    IsActive: {
      type: 'boolean',
      default: true,
      title: 'IsActive',
    },
    HasWriteAccess: {
      type: 'boolean',
      default: false,
      title: 'HasWriteAccess',
    },
  },
  required: ['URL', 'Username', 'Password'],
};

const sippFormSchema: any = {
  title: 'Add/Edit Yardi SIPP Credentials',
  type: 'object',
  properties: {
    Domain: {
      type: 'string',
      title: 'Domain',
    },
    VoyagerId: {
      type: 'string',
      title: 'VoyagerId',
    },
    UserName: {
      type: 'string',
      title: 'Username',
    },
    Password: {
      type: 'string',
      title: 'Password',
    },
    ServerName: {
      type: 'string',
      title: 'ServerName',
    },
    Database: {
      type: 'string',
      title: 'Database',
    },
    Platform: {
      type: 'string',
      default: 'SQL Server',
      title: 'Platform',
    },
    InterfaceEntity: {
      type: 'string',
      default: 'LeaseMax',
      readonly: true,
      title: 'Interface Entity',
    },
  },
  required: [
    'Domain',
    'VoyagerId',
    'UserName',
    'Password',
    'ServerName',
    'Database',
    'Platform',
  ],
};

const sftpFormSchema: any = {
  title: 'Add SFTP Credentials',
  type: 'object',
  properties: {
    SFTPUser: {
      type: 'string',
      title: 'SFTPUser',
    },
    Password: {
      type: 'string',
      title: 'Password',
    },
    SFTPFolder: {
      type: 'string',
      title: 'SFTPFolder',
      default: 'shared',
    },
    SFTPOutFolder: {
      type: 'string',
      title: 'SFTPOutFolder',
      default: 'out',
    },
    PrivateKey: {
      type: 'string',
      title: 'PrivateKey',
    },
    PublicKey: {
      type: 'string',
      title: 'PublicKey',
    },
  },
  required: ['SFTPUser'],
};

const AddCredentials = ({
  clientId,
  credentialType,
  credential,
  onSubmit,
}: {
  clientId: string;
  credentialType?: string;
  credential?: any;
  onSubmit?: () => void;
}) => {
  const entrataFormSchema: any = produce(
    entrataCredentialsForm,
    (draftState) => {}
  );
  const dispatch = useDispatch();

  const handleEntrataFormSubmit = ({ formData }: any) => {
    if (credential) {
      dispatch(updateEntrataCredentials(formData, clientId));
    } else {
      dispatch(addEntrataCredentials(formData, clientId));
    }
    onSubmit && onSubmit();
  };

  const handleSippFormSubmit = ({ formData }: any) => {
    if (credential) {
      dispatch(updateYardiSippCredentials(formData, clientId));
    } else dispatch(addYardiSippCredentials(formData, clientId));
    onSubmit && onSubmit();
  };

  const handleSFTPFormSubmit = ({ formData }: any) => {
    if (credential) {
      dispatch(updateSFTPCredentials(formData, clientId));
    } else dispatch(addSFTPCredentials(formData, clientId));
    onSubmit && onSubmit();
  };

  if (credentialType) {
    switch (credentialType) {
      case 'sftp':
        return (
          <div>
            <div>
              {' '}
              Run <blockquote>Setup SFTP</blockquote> task from task list to
              create new credentials or enter credentials below
            </div>
            <br />
            <br />
            <Form
              schema={sftpFormSchema}
              validator={validator}
              onSubmit={handleSFTPFormSubmit}
              formData={credential}
            />
          </div>
        );
      case 'entrataApi':
        return (
          <Form
            schema={entrataFormSchema}
            validator={validator}
            onSubmit={handleEntrataFormSubmit}
            formData={credential}
          />
        );
      case 'sipp':
        return (
          <Form
            schema={sippFormSchema}
            validator={validator}
            onSubmit={handleSippFormSubmit}
            formData={credential}
          />
        );
      default:
        return <div>Unsupported Credential type</div>;
    }
  }
  return <div>Unsupported Credential type</div>;
};

export default AddCredentials;
